import * as React from 'react';
import { FC, ReactElement } from 'react';

import { PullToRefresh } from 'react-js-pull-to-refresh';

import useMediaQuery, { MediaQuery } from 'hooks/use-media-query';
import noop from 'utils/noop';

interface IPullToReload {
  onRefresh(): Promise<any>;
  pullDownThreshold: number;
  triggerHeight: number;
  startInvisible?: boolean;
  enabled?: boolean;
  minimumRefreshTime?: number;
  pullDownContent: ReactElement;
  releaseContent: ReactElement;
  refreshContent: ReactElement;
}

const PullToReload: FC<IPullToReload> = ({
  children,
  onRefresh,
  minimumRefreshTime,
  enabled = true,
  triggerHeight,
  ...props
}) => {
  const minimumRefreshTimePromise = async () => {
    const minimumRefreshDuration = new Promise(res => setTimeout(res, minimumRefreshTime || 1200));
    // Mimicking Promise.allSettled so that this resolves even if refresh fails
    return Promise.all([onRefresh(), minimumRefreshDuration].map(promise => promise.catch(noop)));
  };

  const isMobile = useMediaQuery(MediaQuery.Mobile);

  return isMobile ? (
    <PullToRefresh
      {...props}
      triggerHeight={enabled ? triggerHeight : 0}
      onRefresh={minimumRefreshTimePromise}
    >
      {children}
    </PullToRefresh>
  ) : (
    <>{children}</>
  );
};

export default PullToReload;
